(function () {
  "use strict";

  function initialiseSizeFinder(root) {
    if (!root || root.dataset.qalbiSizeFinderInitialised === "true") {
      return;
    }

    var trigger = root.querySelector("[data-qalbi-size-finder-trigger]");
    var modal = root.querySelector("[data-qalbi-size-finder]");

    if (!trigger || !modal) {
      return;
    }

    var dialog = modal.querySelector(".qalbi-size-finder__dialog");
    var formPanel = modal.querySelector("[data-qalbi-size-finder-form]");
    var resultPanel = modal.querySelector("[data-qalbi-size-finder-result]");

    var heightInput = modal.querySelector("[data-qalbi-height]");
    var heightOutput = modal.querySelector("[data-qalbi-height-output]");
    var heightMinLabel = modal.querySelector("[data-qalbi-height-min]");
    var heightMaxLabel = modal.querySelector("[data-qalbi-height-max]");

    var heightUnitButtons = modal.querySelectorAll(
      "[data-qalbi-height-unit]"
    );

    var calculateButton = modal.querySelector(
      "[data-qalbi-size-finder-calculate]"
    );

    var errorElement = modal.querySelector(
      "[data-qalbi-size-finder-error]"
    );

    var resultSize = modal.querySelector("[data-qalbi-size-result]");
    var resultLength = modal.querySelector("[data-qalbi-result-length]");
    var resultChest = modal.querySelector("[data-qalbi-result-chest]");
    var resultCopy = modal.querySelector(
      "[data-qalbi-size-result-copy]"
    );

    var selectButton = modal.querySelector(
      "[data-qalbi-size-finder-select]"
    );

    var editButton = modal.querySelector(
      "[data-qalbi-size-finder-edit]"
    );

    if (
      !dialog ||
      !formPanel ||
      !resultPanel ||
      !heightInput ||
      !heightOutput ||
      !calculateButton ||
      !errorElement ||
      !resultSize ||
      !resultLength ||
      !resultChest ||
      !resultCopy ||
      !selectButton ||
      !editButton
    ) {
      return;
    }

    root.dataset.qalbiSizeFinderInitialised = "true";

    var heightUnit = "imperial";
    var recommendedSize = "";
    var lastFocusedElement = null;

    /*
     * Height determines the garment length.
     * The estimated T-shirt chest determines R or L.
     */
    var sizeRows = [
      {
        minHeight: 62,
        maxHeight: 63,
        length: 52,
        rMaxChest: 38,
        lMaxChest: 42
      },
      {
        minHeight: 64,
        maxHeight: 66,
        length: 54,
        rMaxChest: 40,
        lMaxChest: 44
      },
      {
        minHeight: 67,
        maxHeight: 68,
        length: 56,
        rMaxChest: 40,
        lMaxChest: 44
      },
      {
        minHeight: 69,
        maxHeight: 70,
        length: 58,
        rMaxChest: 40,
        lMaxChest: 46
      },
      {
        minHeight: 71,
        maxHeight: 72,
        length: 60,
        rMaxChest: 42,
        lMaxChest: 46
      },
      {
        minHeight: 73,
        maxHeight: 75,
        length: 62,
        rMaxChest: 42,
        lMaxChest: 46
      }
    ];

    function inchesToFeetText(totalInches) {
      var feet = Math.floor(totalInches / 12);
      var inches = totalInches % 12;

      return feet + " FT " + inches + " IN";
    }

    function inchesToSpokenText(totalInches) {
      var feet = Math.floor(totalInches / 12);
      var inches = totalInches % 12;

      return (
        feet +
        (feet === 1 ? " foot " : " feet ") +
        inches +
        (inches === 1 ? " inch" : " inches")
      );
    }

    function setActiveUnit(buttons, activeButton) {
      Array.prototype.forEach.call(buttons, function (button) {
        var active = button === activeButton;

        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    function updateHeightDisplay() {
      var heightInches = Number(heightInput.value);

      if (heightUnit === "metric") {
        var centimetres = Math.round(heightInches * 2.54);

        heightOutput.textContent = centimetres + " CM";

        heightInput.setAttribute(
          "aria-valuetext",
          centimetres + " centimetres"
        );

        if (heightMinLabel) {
          heightMinLabel.textContent = "157 CM";
        }

        if (heightMaxLabel) {
          heightMaxLabel.textContent = "191 CM";
        }
      } else {
        heightOutput.textContent = inchesToFeetText(heightInches);

        heightInput.setAttribute(
          "aria-valuetext",
          inchesToSpokenText(heightInches)
        );

        if (heightMinLabel) {
          heightMinLabel.textContent = "5 FT 2 IN";
        }

        if (heightMaxLabel) {
          heightMaxLabel.textContent = "6 FT 3 IN";
        }
      }
    }

    function getSelectedShirtSize() {
      return modal.querySelector(
        'input[name^="qalbi-shirt-size-"]:checked'
      );
    }

    function getSizeRow(heightInches) {
      for (var index = 0; index < sizeRows.length; index += 1) {
        var row = sizeRows[index];

        if (
          heightInches >= row.minHeight &&
          heightInches <= row.maxHeight
        ) {
          return row;
        }
      }

      return null;
    }

    function findSizeInput(size) {
      /*
        .qalbi-size-swatch was the legacy theme's swatch wrapper and does not exist in Dawn,
        whose variant picker renders .product-form__input fieldsets instead. Searching only
        the old class found nothing, so every recommendation reported "unavailable".
        Both are matched now so this keeps working either way.
      */
      var inputs = root.querySelectorAll(
        ".qalbi-size-swatch input[type='radio'], .product-form__input input[type='radio']"
      );

      for (var index = 0; index < inputs.length; index += 1) {
        var input = inputs[index];

        if (
          String(input.value).trim().toUpperCase() ===
          String(size).trim().toUpperCase()
        ) {
          return input;
        }
      }

      return null;
    }

    function showError(message) {
      errorElement.textContent = message;
      errorElement.hidden = false;
    }

    function clearError() {
      errorElement.textContent = "";
      errorElement.hidden = true;
    }

    function resetToForm() {
      recommendedSize = "";

      resultPanel.hidden = true;
      formPanel.hidden = false;

      selectButton.disabled = false;
      selectButton.textContent = "Select this size";

      clearError();
    }

    function openModal() {
      lastFocusedElement = document.activeElement;

      resetToForm();

      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");

      document.body.classList.add("qalbi-size-finder-open");

      window.requestAnimationFrame(function () {
        dialog.focus();
      });
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");

      document.body.classList.remove("qalbi-size-finder-open");

      if (
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function"
      ) {
        lastFocusedElement.focus();
      }
    }

    function calculateSize() {
      clearError();

      var heightInches = Number(heightInput.value);
      var shirtInput = getSelectedShirtSize();
      var row = getSizeRow(heightInches);

      if (!shirtInput) {
        showError("Choose your usual T-shirt size.");
        return;
      }

      if (!row) {
        showError(
          "This calculator covers heights from 5 FT 2 IN to 6 FT 3 IN."
        );

        return;
      }

      var shirtSize = shirtInput.value;
      var estimatedChest = Number(
        shirtInput.getAttribute("data-chest")
      );

      if (!estimatedChest) {
        showError("Choose your usual T-shirt size.");
        return;
      }

      if (estimatedChest > row.lMaxChest) {
        showError(
          "Your usual " +
            shirtSize +
            " T-shirt size is above the largest chest option available for this thobe length. Please use the full size guide or contact Qalbi before ordering."
        );

        return;
      }

      var chestOption =
        estimatedChest <= row.rMaxChest ? "R" : "L";

      recommendedSize =
        String(row.length) + chestOption;

      resultSize.textContent = recommendedSize;
      resultLength.textContent = row.length + '"';
      resultChest.textContent = chestOption;

      resultCopy.textContent =
        "Your height gives a " +
        row.length +
        '-inch thobe length. Your usual UK ' +
        shirtSize +
        " T-shirt size indicates the " +
        (chestOption === "R" ? "closer" : "wider") +
        " chest option. R and L do not change the garment length.";

      var sizeInput = findSizeInput(recommendedSize);

      if (!sizeInput || sizeInput.disabled) {
        selectButton.disabled = true;
        selectButton.textContent = "Recommended size unavailable";

        resultCopy.textContent +=
          " This size is currently unavailable on this product.";
      } else {
        selectButton.disabled = false;
        selectButton.textContent = "Select " + recommendedSize;
      }

      formPanel.hidden = true;
      resultPanel.hidden = false;

      window.requestAnimationFrame(function () {
        resultPanel.focus();
      });
    }

    function getFocusableElements() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll(
          "button:not([disabled]), " +
            "input:not([disabled]), " +
            "[href], " +
            "[tabindex]:not([tabindex='-1'])"
        ),
        function (element) {
          return !element.hidden && element.offsetParent !== null;
        }
      );
    }

    trigger.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        openModal();
      },
      true
    );

    Array.prototype.forEach.call(
      modal.querySelectorAll("[data-qalbi-size-finder-close]"),
      function (closeElement) {
        closeElement.addEventListener("click", closeModal);
      }
    );

    heightInput.addEventListener("input", updateHeightDisplay);

    Array.prototype.forEach.call(heightUnitButtons, function (button) {
      button.addEventListener("click", function () {
        heightUnit = button.getAttribute("data-qalbi-height-unit");

        setActiveUnit(heightUnitButtons, button);
        updateHeightDisplay();
      });
    });

    calculateButton.addEventListener("click", calculateSize);

    editButton.addEventListener("click", function () {
      resetToForm();
      heightInput.focus();
    });

    selectButton.addEventListener("click", function () {
      if (!recommendedSize) {
        return;
      }

      var sizeInput = findSizeInput(recommendedSize);

      if (!sizeInput || sizeInput.disabled) {
        return;
      }

      sizeInput.click();

      sizeInput.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );

      closeModal();
    });

    modal.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== "Tab") {
        return;
      }

      var focusableElements = getFocusableElements();

      if (!focusableElements.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement =
        focusableElements[focusableElements.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === firstElement
      ) {
        event.preventDefault();
        lastElement.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === lastElement
      ) {
        event.preventDefault();
        firstElement.focus();
      }
    });

    updateHeightDisplay();
  }

  function initialiseAll(scope) {
    var context = scope || document;

    if (
      context.matches &&
      context.matches("[data-qalbi-product-root]")
    ) {
      initialiseSizeFinder(context);
    }

    Array.prototype.forEach.call(
      context.querySelectorAll("[data-qalbi-product-root]"),
      initialiseSizeFinder
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialiseAll(document);
    });
  } else {
    initialiseAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialiseAll(event.target);
  });
})();